import { useMutation } from "@tanstack/react-query";
import { logoutApi } from "@/apis/auth/authService";
import { useAuthStore } from "@/store/authStore";
import { Toast } from "@/utils/toast";

export const useMutateLogout = () => {

    const logout = useAuthStore((state) => state.logout);
    return useMutation({
        mutationFn: () => logoutApi(),

        onSuccess: () => {
            Toast.success("Logged out successfully!");
            logout();
        },

        onError: (error: Error) => {
            Toast.error(error.message);
        },
    });
};